import styled from "styled-components";
import {
  ButtonContained,
  ButtonOutlined,
  ButtonText,
  FontStyles,
} from "../../../components";

const Container = styled.div(({ theme }) => {
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(5),
    borderRadius: "15px",
    flex: 1,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "88vw",
    },
  };
});

const InputImage = styled.div(({ theme }) => {
  return {
    ...FontStyles.medium14,
    padding: theme.spacing(1.57, 2.5),

    marginTop: theme.spacing(1.5),
    textOverflow: "ellipsis",

    backgroundColor: theme.palette.primary.contrastText,
    borderBottom: "0px",
    borderRadius: theme.spacing(0.6),
    display: "flex",
    justifyContent: "space-between",
  };
});
const InputImageClick = styled.label(({ theme }) => {
  return {
    width: "100%",
    height: "100%",
    flex: 1,
    cursor: "pointer",
    alignItems: "center",
    overflow: "hidden",
    display: "block",
  };
});
const InputView = styled(ButtonText)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.medium12,
      textDecoration: "underline",
      color: "#24272A",
      padding: 0,
      paddingInline: 6,
      margin: 0,
    },
  };
});

const SendForm = styled(ButtonContained)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.semibold16,

      padding: "16px",
      paddingInline: "20px",
      margin: 0,
    },
  };
});

const Back = styled(ButtonText)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.semibold16,

      color: "#4D585A",
      padding: "8px",
      paddingInline: "12px",
      margin: 0,
    },
  };
});
const Clear = styled(ButtonText)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.semibold16,
      color: "#4D585A",
      padding: "16px",
      paddingInline: "20px",
      margin: 0,
    },
  };
});

const Line = styled.div(({ theme }) => {
  return {
    height: "1px",
    width: "100%",
    backgroundColor: "#24272A",
  };
});

const ButtonsContainer = styled.div(({ theme }) => {
  return {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",
    marginBottom: "16px",
    marginTop: "24px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      marginTop: "8px",
      alignItems: "flex-end",
    },
  };
});
const Styles = {
  Container,
  InputImage,
  InputView,
  InputImageClick,
  Clear,
  SendForm,
  Back,
  Line,
  ButtonsContainer,
};

export default Styles;
